import React from 'react';
import PropTypes from 'prop-types';
import Filter from './Filter';
import SortComponent from './Sort';
import SearchComponent from './Search';

import style from './index.scss';

export const SearchSortAndFilter = (props) => {
  const {
    widgetItemOperations,
    hasFilter,
    hasSort,
    hasSearch,
    applyFilterHandler
  } = props;

  return (
    <div className={style.flexWrapper}>
      <div className={style.filterSortWrapper}>
        {hasFilter && (
          <Filter
            GS={widgetItemOperations}
            applyFilterHandler={applyFilterHandler}
          />
        )}
        {hasSort && <SortComponent {...props} />}
      </div>
      {hasSearch && <SearchComponent {...props} />}
    </div>
  );
};

SearchSortAndFilter.defaultProps = {
  hasSearch: true,
  hasSort: true,
  hasFilter: true,
  applyFilterHandler: null,
  widgetItemOperations: {}
};

SearchSortAndFilter.propTypes = {
  hasSearch: PropTypes.bool,
  hasSort: PropTypes.bool,
  hasFilter: PropTypes.bool,
  applyFilterHandler: PropTypes.func.isRequired,
  widgetItemOperations: PropTypes.object.isRequired
};

export default SearchSortAndFilter;
